export const headers =  {
    'Content-Type': 'application/json',
    'Authorization':window.authorization_token
  }

export function setHeaders(){
  headers.Authorization =window.authorization_token
}